﻿import * as $modal from './_modal'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    textName: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    $('.' + options.pagePrefix + '__item').click(function () {
        var id = $(this).attr('data-id')
        var text = $('.' + options.pagePrefix + '__textplh--' + id).html()

        $modal.show(text, true, false, false)
    })

    if (options.textName && options.textName.length > 0) {
        $modal.show($('.' + options.pagePrefix + '__textplh--' + options.textName).html(), true, false, false)
    }
}
